import { Link } from "react-router-dom";
import "./SiteButton.scss";

const SiteButton = ({
  children,
  variant = "primary",
  to,
  href,
  onClick,
  type = "button",
  className = "",
  disabled,
}) => {
  const cls = `mu-btn mu-btn--${variant} ${className}`.trim();

  if (to) {
    return (
      <Link className={cls} to={to} onClick={onClick}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a className={cls} href={href} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }

  return (
    <button className={cls} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default SiteButton;
